<template>
  <div>
    <div v-if="isLoggedIn" class="">
      <div class="card login-page">
        <div class="card col-md-3 container-fluid already-in">
          <div class="card-header">
            <p> <label> Hallo {{displayName}}, Sie sind bereits angemeldet! </label> </p>
            <label> Was möchten Sie tun? </label>
          </div>
          <div class="card-body">
            <div class="btn-group">
              <button class="btn btn-default akr-button" type="button" @click="toOverview()">
                Zur Übersicht
              </button>
              <button class="btn btn-default akr-button" type="button" @click="logout()">
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="login-page">
        <form class="col-md-12 login-page" style="padding: 15px" @submit.prevent="submitButton">
          <div class="card">
            <div class="container-fluid login-seite" style="width: 120px;">
              <label class="login-cap"> Login </label>
            </div>
            <div class="card container-fluid" style="width: 325px; padding-left: 35px; padding-right: 35px; border-color: white;">
              <div class="login-box closed">
                <div class="card-header">
                  <p> <label> Willkommen! </label> </p>
                  <label> Bitte melden Sie sich an. </label>
                </div>
                <div class="card-body">
                  <div>
                    <div class="input-group-sm login-field">
                      <div class="form-control" style="height: 30px;">
                        <i class="fa fa-user"></i>
                        <input class="" v-bind:class="checkIfEmpty(username)" type="text" placeholder="Benutzername" v-model="username"/>
                      </div>
                    </div>
                    <div class="input-group-sm login-field">
                      <div class="form-control" style="height: 30px;">
                        <i class="fa fa-unlock-alt"></i>
                        <input class="" v-bind:class="checkIfEmpty(password)" type="password" placeholder="Passwort" v-model="password"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="btn-group">
                    <button class="btn btn-default akr-button login-button" type="submit">
                      Login
                    </button>
                  </div>
                </div>
                <div v-if="error" class="error" v-html="errorMessage">
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
var crypto = require('crypto')

export default {
  components: {},
  data () {
    return {
      username: '',
      password: '',
      displayName: '',
      localRecords: [],
      error: 0
    }
  },
  created () {
  },
  methods: {
    isEmpty (word) {
      return (word === '') ? 'nicole' : 'nicole-text'
    },
    submitButton () {
      if (this.pwStrategy !== 'sso') this.handleSubmit()
    },
    async handleSubmit () {
      var shasum = crypto.createHash('sha256')
      shasum.update(this.password)
      var params = {
        username: this.username,
        password: shasum.digest('hex')
      }
      try {
        var response = await api.createPost('login', params)
        this.displayName = response.user.givenName
        this.$router.replace(this.$route.query.redirect || '/patient')
      } catch (err) {
        this.error = err.response.status
      }
    },
    checkIfEmpty (word) {
      return this.isEmpty(word)
    },
    logout () {
      this.displayName = ''
      this.$router.replace('/logout')
    },
    toOverview () {
      this.$router.replace(this.$route.query.redirect || '/admin')
    }
  },
  computed: {
    isLoggedIn () {
      return (!!this.displayName)
    },
    errorMessage () {
      var messages = {
        '401': 'Falscher Benutzername oder falsches Passwort!<br>Bitte versuchen Sie es erneut.',
        '500': 'Es liegt ein internes Problem mit dem Server vor.'
      }
      var message = (messages[this.error]) ? messages[this.error] : 'Ein unerwarteter Fehler ist aufgetreten.'
      return message
    }
  },
  watch: {
  }
}
</script>

<style>
.login-page {
  background-color: rgb(203,203,210,0.15);
}
.login-cap {
  font-size: 24px !important;
  margin: 10px;
  margin-top: 20px;
  color: black !important;
}
.login-box {
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-color: #ddd;
}
.closed {
  border-top: 1px solid;
  border-color: #ddd;
}
.signin{
  margin-left: 60px;
  padding: 10px;
}
.akr-button {
  border-color: darkgrey !important;
  background-color: #a5181b !important;
}
.login-button {
  width: 218px;
  margin-left: 3px !important;
}
.login-seite {
  margin-bottom: 15px !important;
}
.already-in {
  margin: 15px;
}
.error {
  padding: 15px;
  font-size: 12px;
  text-transform: uppercase;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  color: rgb(31,78,72);
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue